import { render, staticRenderFns } from "./FormDataSource.vue?vue&type=template&id=3a0fe08e&scoped=true&"
import script from "./FormDataSource.vue?vue&type=script&lang=js&"
export * from "./FormDataSource.vue?vue&type=script&lang=js&"
import style0 from "./FormDataSource.vue?vue&type=style&index=0&id=3a0fe08e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0fe08e",
  null
  
)

export default component.exports